<script setup>
// 컨텐츠 평가
import SurveyCard from '@/components/calendar/drawer/pages/cards/SurveyCard.vue';
import { addContentLogAPI } from '@/api/logServiceApi';

const props = defineProps({
  ratingResult: Number,
  ratingStatus: Boolean,
});
const emit = defineEmits(['postRate', 'goToOverView']);

const postRate = (rate) => emit('postRate', rate);
const goToCoverPage = () => {
  addContentLogAPI('as_summary_btn_restart');
  emit('goToOverView');
};
</script>

<template>
  <div class="contents09-wrapper">
    <div class="contents09-center">
      <SurveyCard
        :ratingResult="ratingResult"
        :ratingStatus="ratingStatus"
        @postRate="postRate"
      />
      <div class="summary-replay">
        <button class="replay-btn content_review_button_restart" @click="goToCoverPage()">
          <i class="return-icon"></i>
          다시보기
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.contents09-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  min-height: 100%;
  background: #fff;
}

.contents09-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
  width: 100%;
  max-width: 400px;
  padding: 40px 20px;
}

.summary-replay {
  display: flex;
  justify-content: center;

  .replay-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 24px;
    border: 1px solid #ebebeb;
    border-radius: 8px;
    background: #fff;
    font-family: Pretendard;
    font-size: 14px;
    font-weight: 500;
    color: #333;
    cursor: pointer;

    &:hover {
      background: #f8f8f8;
    }

    .return-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url('@manseImages/return-icon.svg') center no-repeat;
      background-size: contain;
    }
  }
}
</style>
